// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import { installClientDiagnostics } from './utils/clientDiagnostics';

import VideoPlayer from 'vue-video-player/src';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
import wx from 'weixin-js-sdk/index';
import './assets/styles/global.css';
import { Form, button, Field, Toast, Area, Popup, Cell, Picker, Checkbox, CheckboxGroup, Dialog, Tab, Tabs, Radio, RadioGroup, Loading, Swipe, SwipeItem, Lazyload } from 'vant';

installClientDiagnostics(Vue, router);
Vue.use(wx);
Vue.use(VideoPlayer);
Vue.use(Dialog);
Vue.use(button);
Vue.use(Form);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Picker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload, {
  lazyComponent: true
});
// import Vant from 'vant'
// import 'vant/lib/index.css'
Vue.config.productionTip = false;
// Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js